module.exports = __webpack_public_path__ + "img/3.6d5b6669.png";